import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { ROUTES } from './routes';
import { ButtonLink, Panel } from '@/components/ui';

/**
 * Route-level error screen. Catches render and loader failures so a single
 * broken page cannot take the whole app down to a blank screen.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();

  const { title, detail } = isRouteErrorResponse(error)
    ? { title: `${error.status} ${error.statusText}`, detail: 'That page could not be found.' }
    : {
        title: 'Something went wrong',
        detail: error instanceof Error ? error.message : 'An unexpected error occurred.',
      };

  return (
    <div className="grid min-h-dvh place-items-center px-4">
      <Panel className="w-full max-w-md text-center">
        <h1 className="mb-2 text-xl font-extrabold tracking-[-0.5px]">{title}</h1>
        <p className="mb-5 font-mono text-[11px] text-content-muted">{detail}</p>
        <ButtonLink to={ROUTES.home} variant="primary">
          Back to dashboard
        </ButtonLink>
      </Panel>
    </div>
  );
}
